let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("M926c")).then(() => parcelRequire('54Fog'));